import styles from "./PrintReturnBanner.module.scss";
import MiscellaneousWarning from "../../../../../common/icons/MiscellaneousWarning.tsx";
import { FormattedMessage } from "react-intl";
import { clsx } from "clsx";
import BaseLinkOrButton from "../../../../../common/core-ui/BaseLinkOrButton.tsx";
import { useState } from "react";
import PrintReturnDialog from "./PrintReturnDialog.tsx";
import { useCoursesLoaderData } from "../coursesLoader.ts";
import PrintReturnSummary from "./PrintReturnSummary.tsx";
import BannerContainer from "common/core-ui/BannerContainer.tsx";

export default function PrintReturnBanner() {
  const [showingDetails, setShowingDetails] = useState(false);
  const { currentTerm } = useCoursesLoaderData();

  return (
    <div role="alert" aria-live="polite">
      {!!currentTerm?.printInfo?.pendingReturns.length && (
        <>
          <div className={styles.bannerOuter} data-testid="print-return-banner">
            <BannerContainer
              className={styles.banner}
              icon={<MiscellaneousWarning className={styles.icon} />}
            >
              <PrintReturnSummary printInfo={currentTerm.printInfo} />
              {/* Wrapper prevents button from stretching to full width on small screens */}
              <div className={styles.viewDetails}>
                <BaseLinkOrButton
                  onClick={() => setShowingDetails(true)}
                  className={clsx("vst-link", "vst-link-variant-black")}
                >
                  <FormattedMessage defaultMessage="View Details" />
                </BaseLinkOrButton>
              </div>
            </BannerContainer>
          </div>
          {showingDetails && (
            <PrintReturnDialog
              onRequestClose={() => setShowingDetails(false)}
            />
          )}
        </>
      )}
    </div>
  );
}
